import { render, staticRenderFns } from "./MsgRightText.vue?vue&type=template&id=3fa2bf00&scoped=true&"
import script from "./MsgRightText.vue?vue&type=script&lang=js&"
export * from "./MsgRightText.vue?vue&type=script&lang=js&"
import style0 from "./MsgRightText.vue?vue&type=style&index=0&id=3fa2bf00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa2bf00",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\job_hymn\\hymn-business02\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3fa2bf00')) {
      api.createRecord('3fa2bf00', component.options)
    } else {
      api.reload('3fa2bf00', component.options)
    }
    module.hot.accept("./MsgRightText.vue?vue&type=template&id=3fa2bf00&scoped=true&", function () {
      api.rerender('3fa2bf00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/service/msg/MsgRightText.vue"
export default component.exports